import { alpha } from "@mui/material/styles";

export const statusColors = (s) => {
  const key = (s || "").toString().toLowerCase();

  const map = {
    waiting: "#42A5F5",
    sent: "#C5C5C5",
    confirm: "#FFBF00",
    payed: "#008000",
    cancel: "#FF0000",
  };

  const base = map[key] || "#FFFFFF";

  return alpha(base, 0.5);
};
